
//subscription dialog used for subscribing item in ShoppingBag

(function($) {


    if (typeof ori != "object") return;

    var self = null,
        isSubscriptionEventBound = false,
        HIDDEN = 'hidden',
        PERSONAL = "personal",
        CONSUMER = "consumer",
        NEW_SUBSCRIBER = "new",
        KENDO_DROPDOWNLIST_ID = "kendoDropDownList",
        SUBSCRIPTION_WINDOW = "#SubscriptionWindow",
        KENDO_RADIO_ID = "kendoRadioButton",
        CONSUMER_SUBSCRIPTION_INPUT_CHECKED = 'input[name=subscription-consumer]:checked',
        INPUT_CHECKED = ':checked',
        SUBSCRIPTION_PACKAGE = 'input[name=subscription-package]',
        SUBSCRIPTION_PACKAGE_INPUT_FIRST = SUBSCRIPTION_PACKAGE + ':first',
        MY_CONSUMERS_DATA = "[data-my-consumers]",
        KENDO_TEMPLATE_SUBSCRIPTION_DIALOG = "#kendo-template-subscription-dialog",
        SUBSCRIPTION_DIALOG = "#subscription-dialog",
        SUBSCRIBE_BUTTON = "#subscription-subscribe",
        FIRST_NAME_INPUT ="#subscription-first-name",
        LAST_NAME_INPUT = "#subscription-last-name",
        MY_CONSUMERS_WRAPPER = '.w-subscription-my-consumers',
        MY_CONSUMERS_DROPDOWN = "#subscription-my-consumers",
        NEW_CUSTOMER_FORM = "#new-customer-form",

        SUBSCRIPTION_REPLACEMENT_BUTTON = '.js-subscription-replacement',
        DATA_BASKET_PRODUCTS = "[data-basket-products]",
        SUBSCRIBE_ITEM = DATA_BASKET_PRODUCTS + " .js-subscribe-item",
        CANCEL_SUBSCRIPTION = DATA_BASKET_PRODUCTS + " .js-cancel-subscription",

        CUSTOMER_ID = "customer-id",
        PACKAGE_ID = "package-id",

        DELAY_SUBSCRIPTION = ".js-delay-subscription",
        SUBSCRIPTION_ITEMS_SECTION_TEMPLATE = "#kendo-template-subscription-items-section",
        SUBSCRIPTION_SECTION = "#subscription-items-section",
        SUBSCRIPTION_ID = "subscription-id",
        SUBSCRIPTION_STEP = "subscription-step",
        SUBSCRIPTION_CYCLE = "subscription-cycle",

        subscriptionItemsSectionTemplate = null,

        renderedTimestamp = new Date();

    ori.shopping.addModule("subscription", {

        init: function(options) {
            self = this;
            self.info("INIT");
            self.setOptions(options);
            setSubscriptionTemplate();
            self.compileSubscriptionTemplate();
        },

        subscribeProductItem: function(controllerActionUrl, itemCode, packageId, consumerId, firstName, lastName) {
            var $dialog = $(SUBSCRIPTION_DIALOG),
                $popupWindow = $dialog.parents('.k-window'),
                popupWindow = $(SUBSCRIPTION_WINDOW).data("kendoWindow"),
                popupActions = popupWindow.options['actions'];

            if (consumerId != null) {
                self.info("Calling subscribeProductItem request, productCode: %s, package: %s for %s...",
                    itemCode, packageId, consumerId
                );
            } else if (lastName != null) {
                self.info("Calling subscribeProductItem request, productCode: %s, package: %s for %s %s...",
                    itemCode, packageId, firstName, lastName
                );
            } else {
                self.info("Calling subscribeProductItem request, productCode: %s, package: %s...",
                    itemCode, packageId
                );
            }

            ori.spinner.applyOverlayTo($popupWindow);
            popupWindow.setOptions({ modal: true, actions: [] });   // forbid popup to be closed
            $.get(controllerActionUrl, { itemCode: itemCode, packageId: packageId, consumerId: consumerId, firstName: firstName, lastName: lastName })
                .always(function() {
                    popupWindow.setOptions({ modal: false, actions: popupActions });
                    ori.spinner.removeOverlayFrom($popupWindow);
                })
                .done(function(data) {
                    if (data.errorMessage) {
                        self.displayErrorValidation($(LAST_NAME_INPUT, SUBSCRIPTION_DIALOG), false, data.errorMessage);
                        self.error("Subscription failed due to business reason: " + data.errorMessage);
                        return;
                    }
                    popupWindow.close();

                    self.info("subscribeProductItem call successful");
                    if (typeof ori.shopping != "undefined" && typeof ori.shopping.wizard != "undefined" && typeof ori.shopping.wizard.shoppingBagPageId != "undefined") {
                        ori.shopping.wizard.updateShoppingContext(data, ori.shopping.wizard.shoppingBagPageId);
                    }
                })
                .fail(function(data) {
                    self.error("subscribeProductItem call failed");
                    ori.displayError(self.options.tr.ajaxError.title, self.options.tr.ajaxError.message);
                });
        },

        createDialog: function(itemCode, item, isEndCustomer, controllerAction) {
            createSubscriptionDialog(itemCode, item, isEndCustomer, controllerAction);
        },

        confirmSubscriptionRemove: function() {
            // cancel subscription in shopping context
            self.cancelSubscription(this.element.data(CUSTOMER_ID), this.element.data(SUBSCRIPTION_ID), this.element.data(PACKAGE_ID));
            $("[popupId='ConfirmSubscriptionDeleteDialog']").kendoWindow("close");
        },

        denySubscriptionRemove: function () {
            // don't cancel subscription in shopping context
            $("[popupId='ConfirmSubscriptionDeleteDialog']").kendoWindow("close");
        },

        showSubscriptionReplacement: function(item) {
            if (item != null) {
                if (!ori.product.detailPopupSlider) {
                    self.error("ori.product.detailPopupSlider module was not loaded.");
                    return;
                }

                var $pageContainer = ori.shopping.getPageContainer(),
                    $link = $pageContainer.find(SUBSCRIPTION_REPLACEMENT_BUTTON + ":eq(0)"),
                    replacementOptions = {
                        productTemplate: {
                            quantityEnabled: false,
                            submitBtnText: $link.text()
                        },
                        submitCallback: function(e) {
                            e.preventDefault();

                            var $form = $(e.currentTarget),
                                $productCodeInput = $form.find('input[name="productCode"]'),
                                $subscriptionIdInput = $form.find('input[name="subscriptionId"]'),
                                $droppingIdInput = $form.find('input[name="droppingId"]'),
                                data = {
                                    newItemCode: $productCodeInput.val(),
                                    droppingId: $droppingIdInput.val(),
                                    subscriptionId: $subscriptionIdInput.val()
                                };

                            self.info(
                                "Subscription replacing %s by %s ...",
                                item.ItemCode, data.newItemCode
                            );

                            $.post(self.options.url.replaceSubscriptionItem, data, function(result) {
                                ori.shopping.wizard.updateShoppingContext(result, ori.shopping.wizard.shoppingBagPageId);
                            });
                        }
                    };

                ori.product.detailPopupSlider.init(replacementOptions);
                ori.product.detailPopupSlider.setProductItems(getSubscriptionReplacements(item));
                ori.product.detailPopupSlider.showProductDetailDialog();
            }
        },

        showSubscription: function(lineNumber) {
            var item = ori.shopping.getShoppingBagItem(lineNumber);
            if (item != null) {
                if (!item.Subscription || !item.Subscription.Packages) {
                    self.error("No subscription suggestions found for product.");
                    return;
                }

                var isEndCustomer = ori.shopping.wizard.getShoppingContext().IsEndCustomer;

                self.createDialog(item.ItemCode, item.Subscription, isEndCustomer, self.options.url.subscribeShoppingBagItemUrl);
            } else {
                ori.displayError(self.options.tr.ajaxError.title, self.options.tr.ajaxError.message);
            }
        },

        cancelSubscription: function(consumerId, subscriptionId, packageId) {
            self.info(
                "Calling cancelSubscription request, consumer: %s, subscription: %s, package: %s...",
                consumerId, subscriptionId, packageId
            );
            ori.shopping.showLoading();
            $.get(self.options.url.cancelSubscriptionUrl, { consumerId: consumerId, subscriptionId: subscriptionId, packageId: packageId })
                .done(function(data) {
                    self.info("cancelSubscription call successful");
                    ori.shopping.wizard.updateShoppingContext(data, ori.shopping.wizard.shoppingBagPageId);
                })
                .fail(function() {
                    self.error("cancelSubscription call failed");
                    self.hideLoading();
                    ori.displayError(self.options.tr.ajaxError.title, self.options.tr.ajaxError.message);
                });
        },

        createSubscriptionItemsSection: function(shoppingContext) {
            if (!ori.shopping.wizard.isChanged(ori.shopping.wizard.CTX_SUBSCRIPTION_ITEMS, renderedTimestamp)) {
                return;
            }
            self.info("Update subscription items");
            var shoppingBag = shoppingContext.ShoppingBag;

            if (typeof shoppingBag.Subscriptions == "undefined" ||
                shoppingBag.Subscriptions === null ||
                shoppingBag.Subscriptions.length === 0) {
                return "";
            }

            var section = kendo.render(subscriptionItemsSectionTemplate, [shoppingBag]);

            return section;
        },

        registerSubscriptionEventHandlers: function($context, lineNumber) {
            var $document = $(document),
                clickEvent = self.eventString("click");
            // subscribe product from basket
            $context.find(SUBSCRIBE_ITEM).on(clickEvent, function(e) {
                e.preventDefault();
                self.showSubscription($(this).data(lineNumber));
            });

            // check whether event handler was bound to "document" in order not to duplicate it (fix for more than 1 subscription replacement)
            if (!isSubscriptionEventBound) {
                $document.on(clickEvent, SUBSCRIPTION_REPLACEMENT_BUTTON, function(e) {
                    var $this = $(this);
                    e.preventDefault();
                    if ($this.data("item")) {
                        self.showSubscriptionReplacement($this.data("item"));
                    }
                })

                .on(clickEvent, SUBSCRIPTION_SECTION + " " + DELAY_SUBSCRIPTION, function(e) {
                    e.preventDefault();
                    delaySubscription($(e.target));
                });

                isSubscriptionEventBound = true;
            }

            // cancel subscription in shopping context
            $context.find(CANCEL_SUBSCRIPTION).on(clickEvent, function(e) {
                e.preventDefault();
                var $cancelBtn = $(this);
                var confirmDialog = $("[popupId='ConfirmSubscriptionDeleteDialog']").kendoWindow();
                var confirmDialogButton = $(confirmDialog).find("#subscription-confirm-button");
                confirmDialogButton.data(SUBSCRIPTION_ID, $cancelBtn.data(SUBSCRIPTION_ID));
                confirmDialogButton.data(CUSTOMER_ID, $cancelBtn.data(CUSTOMER_ID));
                confirmDialogButton.data(PACKAGE_ID, $cancelBtn.data(PACKAGE_ID));

                confirmDialog.kendoWindow("open");
            });

        },

        compileSubscriptionTemplate: function() {
            subscriptionItemsSectionTemplate = ori.shopping.getKendoTemplate(SUBSCRIPTION_ITEMS_SECTION_TEMPLATE);
        }

    });

     function delaySubscription($sender) {
        var data = {
            subscriptionId: $sender.data(SUBSCRIPTION_ID),
            step: $sender.data(SUBSCRIPTION_STEP),
            cycle: $sender.data(SUBSCRIPTION_CYCLE)
        }

        $.post(self.options.url.delaySubscription, data, function(result) {
            ori.shopping.wizard.updateShoppingContext(result, ori.shopping.wizard.shoppingBagPageId);
        });
    }

    function setSubscriptionTemplate() {
        var templateContent = $(KENDO_TEMPLATE_SUBSCRIPTION_DIALOG).html();
        if (typeof templateContent === "undefined") {
            self.error("Subscription template is not defined.");
            return;
        }
        self.subscriptionDialogTemplate = kendo.template(templateContent, { useWithBlock: false });
    }

    function createSubscriptionDialog(itemCode, item, isEndCustomer, controllerAction) {
        var result = kendo.render(self.subscriptionDialogTemplate, [{ItemCode: itemCode, IsEndCustomer: isEndCustomer, Subscription: item }]),
            $dialog = $(SUBSCRIPTION_DIALOG);

        $dialog.html(result);
        $dialog.parents('.k-window').addClass('ui-subscription-dialog');

        // first package selection
        var $radio = $dialog.find(SUBSCRIPTION_PACKAGE_INPUT_FIRST);
        if ($radio.data(KENDO_RADIO_ID)) {
            $radio.data(KENDO_RADIO_ID).value(true);
        }

        // bind consumers dropdown
        if (item.Consumers == null || item.Consumers.length == 0) {
            $(MY_CONSUMERS_WRAPPER).addClass(HIDDEN);
        } else {
            $dialog.find(MY_CONSUMERS_DATA).kendoDropDownList({
                dataSource: item.Consumers,
                dataTextField: "Text",
                dataValueField: "Value"
            });
        }

        registerSubscriptionDialogHandlers($dialog, itemCode, controllerAction);
    }

    function registerSubscriptionDialogHandlers($dialog, itemCode, controllerAction) {
        var validator = $dialog.find(NEW_CUSTOMER_FORM).kendoValidator().data("kendoValidator"),
            clickEvent = self.eventString("click");

        $(SUBSCRIBE_BUTTON).on(clickEvent, function(e) {
            e.preventDefault();

            var $subscriptionPackage = $dialog.find(SUBSCRIPTION_PACKAGE),
                packageId = $subscriptionPackage.length == 1 ? $subscriptionPackage.val() : $subscriptionPackage.filter(INPUT_CHECKED).val(),
                consumerType = $dialog.find(CONSUMER_SUBSCRIPTION_INPUT_CHECKED).val();
            switch (consumerType) {
                case PERSONAL:
                    self.subscribeProductItem(controllerAction, itemCode, packageId);
                    break;
                case CONSUMER:
                    var consumerId = $dialog.find(MY_CONSUMERS_DROPDOWN).data(KENDO_DROPDOWNLIST_ID).value();
                    self.subscribeProductItem(controllerAction, itemCode, packageId, consumerId);
                    break;
                case NEW_SUBSCRIBER:
                    // validate form
                    if (!validator.validate()) {
                        return;
                    }
                    var firstName = $(FIRST_NAME_INPUT).val(),
                        lastName = $(LAST_NAME_INPUT).val();
                    self.subscribeProductItem(controllerAction, itemCode, packageId, null, firstName, lastName);
                    break;
                default:
                    self.subscribeProductItem(controllerAction, itemCode, packageId);
                    break;
            }
        });

        $(SUBSCRIPTION_WINDOW).data("kendoWindow").open();
    }

    function getSubscriptionReplacements(item) {
        var offers = item.subscriptionReplacements,
            replacements = [],
            product;
        $(offers).each(function(index, replacement) {
            product = ori.shopping.prepareProductData(replacement);
            product.SubscriptionId = item.subscription_id;
            product.DroppingId = item.dropping_id;
            product.CurrentProduct.IsOutOfStock = false;
            replacements.push(product);
        });

        return replacements;
    }

    self = ori.shopping.subscription;

})(jQuery);